<template>
    <div class="v-menu">
        <button :class="{ active: menu }" @click.stop="openWrapper" class="v-menu__open" type="button">
            <v-icon name="arrow-dropdown" />
        </button>
        <div @click.stop class="v-menu__wrapper" v-show="menu">
            <button @click="$store.commit('canvas/canvasHandler', null)" class="v-menu__close" type="button">
                <v-icon name="close" />
            </button>
            <!-- <router-link :to="path.toLowerCase()" @click.native="closeWrapper" class="v-menu__route">
                <v-icon name="home" />
                <span>Inicio</span>
            </router-link> -->
            <div class="v-menu__dropdown">
                <h3 class="v-menu__title">
                    <v-icon name="arrow-dropdown" />
                    <span>Menú</span>
                </h3>
                <div class="v-menu__options">
                    <!-- <router-link :to="`${path.toLowerCase()}/acerca-de-nosotros`" @click.native="closeWrapper">Nosotros</router-link> -->
                    <!-- <router-link :to="`${path.toLowerCase()}/contacto`" @click.native="closeWrapper">Contacto</router-link>
                    <router-link :to="`${path.toLowerCase()}/terminos-y-condiciones`" @click.native="closeWrapper">Términos y condiciones</router-link>
                    <router-link :to="`${path.toLowerCase()}/politica-de-privacidad`" @click.native="closeWrapper">Política de privacidad</router-link>-->
                </div>
            </div>
            <div class="v-menu__dropdown" v-show="historiesView.length > 0">
                <h3 class="v-menu__title">
                    <v-icon name="arrow-dropdown" />
                    <span>Historial</span>
                </h3>
                <div class="v-menu__options">
                    <router-link :key="inx" :to="out.url" @click.native="closeWrapper" v-for="(out, inx) in historiesView.slice(0, 6)">
                        <img :alt="out.name" :src="`/img/${out.country}.svg`" />
                        <span>{{ out.name }}</span>
                    </router-link>
                    <button @click="clearHV" title="Borrar" type="button">
                        <v-icon name="trash" />
                    </button>
                </div>
            </div>
            <div class="v-menu__dropdown" v-show="historiesSearch.length > 0">
                <h3 class="v-menu__title">
                    <v-icon name="arrow-dropdown" />
                    <span>Lugares buscados</span>
                </h3>
                <div class="v-menu__options">
                    <router-link :key="inx" :to="out.url" @click.native="closeWrapper" v-for="(out, inx) in historiesSearch.slice(0, 6)">
                        <img :alt="out.name" :src="`/img/${out.country}.svg`" />
                        <span>{{ out.name }}</span>
                    </router-link>
                    <button @click="clearHS" title="Borrar" type="button">
                        <v-icon name="trash" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            menu: false
        }
    },
    computed: {
        ...mapGetters({
            historiesSearch: 'local/historiesSearch',
            historiesView: 'local/historiesView',
            path: 'path'
        })
    },
    methods: {
        clearHS() {
            localStorage.removeItem('hs')
            this.$store.dispatch('local/historiesSearchAction')
        },
        clearHV() {
            localStorage.removeItem('hv')
            this.$store.dispatch('local/historiesViewAction')
        },
        openWrapper() {
            const mq = window.matchMedia('(max-width: 992px)')
            if (mq.matches) {
                this.menu = true
                this.$store.commit('canvas/canvasHandler', 'right')
            } else {
                this.menu = !this.menu
            }
        },
        closeWrapper() {
            const mq = window.matchMedia('(max-width: 992px)')

            if (mq.matches) {
                this.$store.commit('canvas/canvas/canvasHandler', null)
            } else {
                this.menu = false
            }
        },
        dropdown(e) {
            const suggestions = document.querySelector('.v-menu__wrapper')
            const mq = window.matchMedia('(max-width: 992px)')
            if (!mq.matches) {
                if (suggestions.contains(e.target)) {
                    this.menu = true
                } else {
                    this.menu = false
                }
            }
        },
        filterDropdown() {
            const elements = document.querySelectorAll('.v-menu__dropdown')
            for (const element of elements) {
                const title = element.querySelector('.v-menu__title')
                title.addEventListener('click', () => {
                    element.classList.toggle('active')
                })
            }
        }
    },
    created() {
        document.addEventListener('click', this.dropdown)
    },
    mounted() {
        this.filterDropdown()
        window.addEventListener('resize', () => {
            this.menu = false
            this.$store.commit('canvas/canvasHandler', null)
        })
    },
    destroyed() {
        document.removeEventListener('click', this.dropdown)
    }
}
</script>

<style lang="scss">
.v-menu {
    position: relative;

    &__close {
        width: 40px;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        margin-right: auto;
        margin-right: 0.5rem;
        display: none;
        background-color: transparent;
        svg {
            height: 20px;
            width: 20px;
        }
    }

    &__open {
        height: 40px;
        width: 40px;
        border-radius: 4px;
        svg {
            height: 24px;
            width: 24px;
            transition: all 0.4s;
            fill: #c9d700;
        }
        &.active {
            svg {
                transform: rotate(180deg);
            }
        }
    }

    &__wrapper {
        position: absolute;
        top: 100%;
        right: 0;
        width: 240px;
        padding: 0.5rem;
        border-radius: 4px;
        background-color: #ffffff;
        box-shadow: 0 0 4px 0 rgba(#000000, 0.2);
    }

    &__route {
        user-select: none;
        cursor: pointer;
        height: 30px;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        display: flex;
        align-items: center;
        svg {
            height: 24px;
            width: 24px;
            margin-right: 0.5rem;
            fill: #c9d700;
        }
    }

    &__dropdown {
        &.active {
            .v-menu {
                &__title {
                    svg {
                        transform: rotate(180deg);
                    }
                }
                &__options {
                    display: block;
                }
            }
        }
    }

    &__title {
        user-select: none;
        cursor: pointer;
        height: 30px;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        display: flex;
        align-items: center;
        svg {
            height: 24px;
            width: 24px;
            margin-right: 0.5rem;
            transition: all 0.4s;
            fill: #c9d700;
        }
    }

    &__options {
        display: none;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        border-radius: 4px;
        overflow: hidden;
        background-color: #f3f3f3;
        a {
            height: 28px;
            padding-left: 0.5rem;
            padding-right: 0.5rem;
            display: flex;
            align-items: center;
            img {
                height: 16px;
                width: 24px;
                margin-right: 0.5rem;
                object-fit: cover;
            }
            span {
                width: calc(100% - (24px + 0.5rem));
                font-size: 0.9rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        button {
            height: 20px;
            background-color: transparent;
            svg {
                height: 100%;
                width: 20px;
                margin-right: 0.2rem;
            }
            &:hover {
                svg {
                    fill: #c9d700;
                }
            }
        }
    }

    @media (max-width: 992px) {
        &__close {
            display: flex;
        }

        &__open {
            svg {
                transform: rotate(270deg);
            }
            &.active {
                svg {
                    transform: rotate(270deg);
                }
            }
        }

        &__wrapper {
            position: fixed;
            top: 0;
            right: -280px;
            height: 100vh;
            width: 280px;
            border-radius: 0;
            box-shadow: none;
        }
    }
}
</style>
